import Model from "../Model";

class Groupcompanies extends Model{

    buildUrl ({ param }) {
        return ['groupview/getgroupbycompany', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new Groupcompanies;